import React, { FC } from 'react';
import { FormInput } from '../../../merchants/FormInput';
import { VALIDATION_FORM_FIELD } from '../../../../constants/sense-js/sense-js-validation-form';
import { ButtonComponent } from '../../../ButtonComponent';
import { InputType } from '../../../form/form-input-constants';

interface Props {
	formik: any;
}

export const VerificationURLForm: FC<Props> = (props) => {
	const { formik } = props;
	return (
		<>
			<div className="fw-bolder fs-5">
				Enter the URL of the site you installed Flex into.
			</div>
			<div className="fs-8 text-muted mb-5">
				e.g. https://www.yoursite.com or https://localhost:8000
			</div>
			<form onSubmit={formik.handleSubmit}>
				<FormInput
					formik={formik}
					fieldName={VALIDATION_FORM_FIELD.URL}
					placeholder="Enter URL"
					inputType={InputType.Text}
					required
					additionalClasses="col-md-12"
					errorMessagePosition={{
						top: '3.5rem',
					}}
					key={VALIDATION_FORM_FIELD.URL}
				/>
				<ButtonComponent buttonName="Verify Installation" type="submit" additionalClass="btn-sm mt-2"/>
			</form>
		</>
	);
};
